import { LockStatusHelper, LockUnlockPermissionsState } from '../helpers/LockStatusHelper';
import { Module } from '../Module';

export interface ILockUnlockPermissionsScope extends ng.IScope {
  message: string;
  lockState: LockUnlockPermissionsState;
  getMessageIconClass: () => string;
}

Module.instance().directive('tbLockUnlockPermissions', () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'lockUnlockPermissions.html',
      scope: {
        message: '=',
        lockState: '='
      },
      link: (scope: ILockUnlockPermissionsScope) => {
        scope.getMessageIconClass = () => LockStatusHelper.getMessageIconClass(scope.lockState);
      }
    };
  }
);
